import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TGetWalletTransactionsResponseSchema,
  TGetWalletTransactionssRequestSchema,
} from "./getWalletTransactions.schema";

export const getWalletTransactions = (axios: IAxiosInstance) => {
  return async (params: TGetWalletTransactionssRequestSchema) => {
    const { startAt, ...rest } = params;

    const response = await axios.noRetry.get<
      IApiResponse<TGetWalletTransactionsResponseSchema>
    >(`/api/wallets/transactions`, {
      params: {
        ...rest,
        start_at: startAt,
      },
    });

    return response.data;
  };
};
